// フォーマット関数（通貨）
function formatCurrency(value) {
  if (typeof value !== 'number' || isNaN(value)) return '¥0';
  return '¥' + value.toLocaleString();
}

// バリアントデータ取得
function getVariantData() {
  const script = document.getElementById('variant-data');
  if (!script) return [];
  try {
    return JSON.parse(script.textContent);
  } catch (e) {
    console.error('バリアントデータの読み込みに失敗:', e);
    return [];
  }
}

// 選択されたバリアントの価格を取得
function getSelectedVariantPrice(variantData, selectedVariantTitle) {
  const variant = variantData.find(v => v.title === selectedVariantTitle);
  return variant ? variant.price / 100 : 0;
}

// 選択されたバリアントの在庫数を取得
function getSelectedVariantInventory(variantData, selectedVariantTitle) {
  const variant = variantData.find(v => v.title === selectedVariantTitle);
  return variant ? variant.inventory_quantity : Infinity;
}

// 商品を予約リストに追加
function addToReserveList(id, title, handle, vendor, variant, quantity = 1) {
  const variantData = getVariantData();
  const price = getSelectedVariantPrice(variantData, variant);
  const maxStock = getSelectedVariantInventory(variantData, variant);
  const uniqueId = Date.now();

  if (quantity > maxStock) {
    alert(`この商品の上限は ${maxStock} 点です`);
    return;
  }

  const reserveList = JSON.parse(localStorage.getItem('reserveList')) || [];

  reserveList.push({
    id: uniqueId,
    title,
    handle,
    vendor,
    price,
    quantity,
    variant
  });

  localStorage.setItem('reserveList', JSON.stringify(reserveList));
  alert('予約リストに追加しました');
  updateReserveIconVisibility();
  updateGoogleFormLink();
}

// 商品をリストから削除
function removeFromReserveList(id) {
  const reserveList = JSON.parse(localStorage.getItem('reserveList')) || [];
  const updatedList = reserveList.filter(item => item.id !== id);
  localStorage.setItem('reserveList', JSON.stringify(updatedList));
  renderReserveList();
  updateReserveIconVisibility();
  updateGoogleFormLink();
}

// 予約リストを表示
function renderReserveList() {
  const reserveList = JSON.parse(localStorage.getItem('reserveList')) || [];
  const output = document.getElementById('reserve-list-output');
  if (!output) return;

  if (reserveList.length === 0) {
    output.innerHTML = '<p>現在、予約リストに商品はありません。</p>';
    return;
  }

  let table = '<table class="reserve-table" style="width: 100%; border-collapse: collapse;">';
  table += `
    <thead>
      <tr>
        <th>品番</th>
        <th>商品名</th>
        <th>サイズ</th>
        <th>単価 (税込)</th>
        <th>数量</th>
        <th>小計 (税込)</th>
        <th>削除</th>
      </tr>
    </thead>
    <tbody>
  `;

  reserveList.forEach(item => {
    const priceExTax = item.price;
    const priceIncTax = Math.round(priceExTax * 1.1);
    const subtotalExTax = priceExTax * item.quantity;
    const subtotalIncTax = Math.round(priceIncTax * item.quantity);

    table += `
      <tr>
        <td>${item.vendor}</td>
        <td><a href="/products/${item.handle}" target="_blank">${item.title}</a></td>
        <td>${item.variant || '-'}</td>
        <td>${formatCurrency(priceExTax)} (税込${formatCurrency(priceIncTax)})</td>
        <td>${item.quantity}</td>
        <td>${formatCurrency(subtotalExTax)} (税込${formatCurrency(subtotalIncTax)})</td>
        <td><button onclick="removeFromReserveList(${item.id})">削除</button></td>
      </tr>
    `;
  });

  table += '</tbody></table>';
  output.innerHTML = table;
}

// ヘッダーのアイコン表示を制御
function updateReserveIconVisibility() {
  const reserveList = JSON.parse(localStorage.getItem('reserveList')) || [];
  const icon = document.getElementById('reserve-link-wrapper');
  if (icon) {
    icon.style.display = reserveList.length > 0 ? 'inline-flex' : 'none';
  }
}

// Googleフォームのリンクを更新
function updateGoogleFormLink() {
  const reserveList = JSON.parse(localStorage.getItem('reserveList')) || [];
  const reserveButton = document.getElementById('go-to-google-form');
  if (!reserveButton) return;

  if (reserveList.length === 0) {
    reserveButton.href = '#';
    return;
  }

  const textData = reserveList.map(item => {
    const priceExTax = item.price;
    const priceIncTax = Math.round(priceExTax * 1.1);
    const subtotalExTax = priceExTax * item.quantity;
    const subtotalIncTax = Math.round(priceIncTax * item.quantity);
    return `${item.vendor}｜${item.title}${item.variant ? `（${item.variant}）` : ''}｜¥${priceExTax.toLocaleString()}(税込¥${priceIncTax.toLocaleString()})｜${item.quantity}｜¥${subtotalExTax.toLocaleString()}(税込¥${subtotalIncTax.toLocaleString()})`;
  }).join('\n');

  const encodedText = encodeURIComponent(textData);
  const formBaseUrl = 'https://docs.google.com/forms/d/e/1FAIpQLSfXOty71kzjGmn3t_O657zfSbRvKRTP3aC0y7fP0ow1_si0UA/viewform';
  const entryParam = `entry.1015551685=${encodedText}`;
  const fullUrl = `${formBaseUrl}?usp=pp_url&${entryParam}`;

  reserveButton.href = fullUrl;
}

// ボタンから値を受け取って登録
function handleAddToReserve(button) {
  const id = parseInt(button.dataset.productId, 10);
  const title = button.dataset.productTitle;
  const handle = button.dataset.productHandle;
  const vendor = button.dataset.productVendor;
  // サイズ選択があれば取得、なければ variant title を使う
let variant = '';
const sizeInput = document.querySelector('input[name^="サイズ"]:checked');
if (sizeInput) {
  variant = sizeInput.value;
} else {
  const variantData = getVariantData();
  if (variantData.length === 1) {
    variant = variantData[0].title;
  }
}

  const quantity = parseInt(document.querySelector('input[name="quantity"]')?.value || '1', 10);

  addToReserveList(id, title, handle, vendor, variant, quantity);
}

// DOM準備後の初期処理
document.addEventListener('DOMContentLoaded', function () {
  renderReserveList();
  updateReserveIconVisibility();
  updateGoogleFormLink();

  const variantData = getVariantData();

  const updateQuantityMax = () => {
    const selectedTitle = document.querySelector('input[name^="サイズ"]:checked')?.value;
    const variant = variantData.find(v => v.title === selectedTitle);
    if (!variant) return;

    const quantityInput = document.querySelector('input[name="quantity"]');
    if (quantityInput) {
      quantityInput.setAttribute('max', variant.inventory_quantity);
    }
  };

  updateQuantityMax();

  const sizeRadios = document.querySelectorAll('input[name^="サイズ"]');
  sizeRadios.forEach(radio => {
    radio.addEventListener('change', updateQuantityMax);
  });
});
